import "scenes/Breaktime.scss";
import { useState } from "react";
import PropTypes from "prop-types";
import exact from "prop-types-exact";
import Footer from "common/Footer.js";
import { characterPropTypes } from "elements/character/Character.js";
import { success, loFiClick } from "common/sounds.js";
import { ReactComponent as LightSvg } from "elements/items/light.svg";
import { allBadges, getAvailableBadgesFor } from "elements/badges/badges.js";
import Badges from "modals/Badges.js";
import BadgeAwarded from "modals/BadgeAwarded.js";
import AvailableItemsAndSelections from "modals/AvailableItemsAndSelections.js";

const hiddenItemBadgeAwarded = "energy-saving-expert";

const availableItems = ["watching-tv", "doing-sports", "playing-outside", "charity-work"];

const Breaktime = ({
  t,
  character,
  addSelection,
  addBadge,
  badges,
  restartScene,
  restartGame,
  goToNextScene,
  battery
}) => {
  const [hiddenItemFound, setHiddenItemFound] = useState(false);
  const [selectedItem, setSelectedItem] = useState(undefined);
  const [openModal, setOpenModal] = useState();
  const [sceneCompleted, setSceneCompleted] = useState(false);

  const hiddenItemClicked = () => {
    if (hiddenItemFound) return;
    setOpenModal("badgeAwarded");
    setHiddenItemFound(true);
    addBadge(hiddenItemBadgeAwarded);
    success();
  };

  const itemClicked = item => {
    if (sceneCompleted) return;
    setSelectedItem(item);
    addSelection(item);
    loFiClick();
    setSceneCompleted(true);
  };

  return (
    <div className="Breaktime scene">
      <div className="background-elements">
        <div className="item shelves-poster"></div>
      </div>
      <div className="primary-elements">
        <button onClick={hiddenItemClicked} className="item light" disabled={hiddenItemFound} title={t("light")}>
          <LightSvg />
        </button>
        <div className="item window">
          {availableItems.map(item => (
            <button
              key={item}
              onClick={() => itemClicked(item)}
              className={`item ${item}${selectedItem === item ? " selected" : ""}`}
              title={t(item.replace(/-/g, "_"))}
              disabled={sceneCompleted}
            >
              <label>{t(item.replace(/-/g, "_"))}</label>
            </button>
          ))}
        </div>
      </div>

      <Footer
        t={t}
        openAvailableItemsAndSelectionsModal={() => setOpenModal("availableItemsAndSelections")}
        badgesCount={badges.length}
        openBadgesModal={() => setOpenModal("badges")}
        restartScene={sceneCompleted ? restartScene : undefined}
        restartGame={restartGame}
        goToNextScene={sceneCompleted ? goToNextScene : undefined}
      />
      {battery}
      <BadgeAwarded
        t={t}
        badge={hiddenItemBadgeAwarded}
        isOpen={openModal === "badgeAwarded"}
        closeModal={() => setOpenModal(undefined)}
      />
      <Badges
        t={t}
        badges={badges}
        availableBadges={getAvailableBadgesFor(character.type)}
        isOpen={openModal === "badges"}
        closeModal={() => setOpenModal(undefined)}
      />
      <AvailableItemsAndSelections
        t={t}
        availableItems={availableItems}
        selections={selectedItem === undefined ? undefined : [selectedItem]} // When the user has selected an item, show that one as the selections.
        isOpen={openModal === "availableItemsAndSelections"}
        closeModal={() => setOpenModal(undefined)}
      />
    </div>
  );
};

Breaktime.propTypes = exact({
  t: PropTypes.func.isRequired,
  character: characterPropTypes.isRequired,
  addSelection: PropTypes.func.isRequired,
  badges: PropTypes.arrayOf(PropTypes.oneOf(allBadges)).isRequired,
  addBadge: PropTypes.func.isRequired,
  restartScene: PropTypes.func.isRequired,
  restartGame: PropTypes.func.isRequired,
  goToNextScene: PropTypes.func.isRequired,
  battery: PropTypes.element.isRequired
});

export default Breaktime;
